var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth.isLoaded)?_c('router-view'):_c('section',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.auth.isLoaded),expression:"!auth.isLoaded"}],staticClass:"app-content-spinner"})}
var staticRenderFns = []

export { render, staticRenderFns }